import { render, staticRenderFns } from "./ClaimReleaseProduct.vue?vue&type=template&id=5c1801cc&scoped=true&"
import script from "./ClaimReleaseProduct.vue?vue&type=script&lang=ts&"
export * from "./ClaimReleaseProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimReleaseProduct.vue?vue&type=style&index=0&id=5c1801cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1801cc",
  null
  
)

export default component.exports